import { pick } from 'underscore';
import { BROADCAST_UPDATE_SCENE_PREVIEW } from 'actions/Types';
import { withCurrentParams } from 'actions/utils';

export default (sourceId, thumbnail = null, sourceSceneUpdate = null) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const {
        broadcastScenes: { scenes },
        broadcastSources: { sources }
      } = getState();

      // Get the scenes to update
      const scenesToUpdate = scenes.filter(scene => {
        const { layers } = scene;
        const source = layers.find(layer => layer.source._id === sourceId);
        return !!source;
      });
      if (scenesToUpdate.length > 0) {
        // Get the source payload to replace in the scene
        const updatePayload = {
          ...pick(
            sources.find(source => source._id === sourceId),
            ['value']
          )
        };

        let finalUpdatedSource = {};

        // replace the value and thumbnail for the source in the layer
        scenesToUpdate.map(scene => {
          const { layers } = scene;
          layers.filter(layer => {
            if (layer.source._id === sourceId) {
              let updatedLayer = {
                ...layer.source,
                ...updatePayload
              };
              if (sourceSceneUpdate) {
                updatedLayer = {
                  ...layer.source,
                  ...updatePayload,
                  ...sourceSceneUpdate
                };
              }
              if (thumbnail) {
                updatedLayer = {
                  ...layer.source,
                  ...updatePayload,
                  thumbnail
                };
              }

              finalUpdatedSource = {
                ...pick(
                  updatedLayer,
                  '_id',
                  'title',
                  'description',
                  'type',
                  'value',
                  'hidden',
                  'order',
                  'thumbnail'
                )
              };
              return (layer.source = finalUpdatedSource);
            }
            return layer;
          });
          return scene;
        });
        const filteredScenes = scenesToUpdate.map(scene => {
          return pick(scene, ['_id']);
        });
        const action = {
          type: BROADCAST_UPDATE_SCENE_PREVIEW,
          request: async apiClient => {
            await apiClient.broadcast.updateScenesSourceLayer(
              teamId,
              eventId,
              broadcastId,
              {
                scenes: filteredScenes,
                source: finalUpdatedSource
              }
            );
          }
        };
        dispatch(action);
      }
      return true;
    }
  );
};
